import { AxiosErrorType } from '~/shared/api'

export const mapMessageErrors = (e: AxiosErrorType) => {
  const errorMessage = e.response?.data.errors
    ?.map((error) => error.detail)
    .join(', ')
  return errorMessage || 'Ошибка сервера.'
}
